(function() {
  'use strict';

  function moveTOCToContentWrapper() {
    const tocWrapper = document.querySelector('.article-toc-wrapper[data-toc-block]');
    const contentWrapper = document.querySelector('.article-template__content-wrapper[data-content-wrapper]');
    
    if (tocWrapper && contentWrapper) {
      const toc = tocWrapper.querySelector('.article-toc');
      if (toc) {
        // Insert TOC as first child of content wrapper
        contentWrapper.insertBefore(toc, contentWrapper.firstChild);
        // Add class to enable grid layout
        contentWrapper.classList.add('has-toc');
        // Hide the original wrapper
        tocWrapper.style.display = 'none';
      }
    }
  }

  function generateTOC() {
    const tocContainer = document.querySelector('.article-toc');
    const contentContainer = document.querySelector('.article-template__content');
    
    if (!tocContainer || !contentContainer) return;
    
    // Move TOC to content wrapper first
    moveTOCToContentWrapper();

    const headings = contentContainer.querySelectorAll('h2, h3');
    if (headings.length === 0) {
      tocContainer.style.display = 'none';
      return;
    }

    const tocList = document.createElement('ul');
    tocList.className = 'article-toc__list';

    headings.forEach((heading, index) => {
      // Generate ID if not present
      let id = heading.id;
      if (!id) {
        id = 'heading-' + index + '-' + heading.textContent.toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        heading.id = id;
      }

      // Create TOC item
      const listItem = document.createElement('li');
      listItem.className = 'article-toc__item article-toc__item--' + heading.tagName.toLowerCase();
      
      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      link.className = 'article-toc__link';
      
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.getElementById(id);
        if (target) {
          const offset = 100; // Offset for fixed header
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
      
      listItem.appendChild(link);
      tocList.appendChild(listItem);
    });

    tocContainer.appendChild(tocList);

    // Highlight active section on scroll
    if (window.IntersectionObserver) {
      const observerOptions = {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            const activeLink = tocContainer.querySelector('a[href="#' + id + '"]');
            if (activeLink) {
              // Remove active class from all links
              tocContainer.querySelectorAll('.article-toc__link').forEach(link => {
                link.classList.remove('active');
              });
              // Add active class to current link
              activeLink.classList.add('active');
            }
          }
        });
      }, observerOptions);

      headings.forEach(heading => {
        observer.observe(heading);
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', generateTOC);
  } else {
    generateTOC();
  }
})();

